<template>
  <div class="reset-password">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ $t('Profile.忘记密码') }}</span>
      <span></span>
    </header>
    <main class="page-body">
      <div class="form-field">
        <div class="label">{{ $t('Profile.账号') }}</div>
        <van-field
          v-model="username"
          clearable
          :placeholder="$t('Profile.请输入账号')"
        ></van-field>
      </div>
      <div class="form-field flexbox align-center">
        <van-field
          v-model="captcha"
          clearable
          :placeholder="$t('Login.请输入图形验证码')"
        ></van-field>
        <img
          id="img-checkcode1"
          :src="imgCodeUrl"
          v-if="rerender"
          @click="onImgClick"
          width="95"
          height="35"
        />
      </div>
      <div class="flexbox align-center form-field">
        <van-field
          v-model="code"
          type="digit"
          clearable
          :maxlength="6"
          :placeholder="$t('Profile.请输入验证码')"
        >
        </van-field>
        <van-button
          type="info"
          class="code-btn"
          :disabled="!username || counting"
          @click="onSend"
        >
          <van-count-down
            :time="60000"
            v-if="counting"
            @finish="counting = false"
          >
            <template #default="timeData">
              <span class="block"
                >{{ $t('Profile.重新获取') }}({{ timeData.seconds }})</span
              >
            </template>
          </van-count-down>
          <span v-else>{{ $t('Profile.获取验证码') }}</span>
        </van-button>
      </div>
      <div class="label">{{ $t('Profile.新密码') }}</div>
      <password-field
        v-model="password"
        clearable
        :placeholder="$t('Profile.请输入新密码')"
      ></password-field>
      <van-button
        class="submit"
        type="info"
        @click="onSubmit"
        :disabled="!valid"
      >
        {{ $t('Profile.确定') }}
      </van-button>
    </main>
  </div>
</template>
<script>
import { BASE_URL } from '@/api/index.js';
import { sendSMSCode, resetPassword } from '@/api/account.js';
//import { $t } from '@/plugins/i18n';
export default {
  data() {
    return {
      username: '',
      password: '',
      code: '',
      captcha: '',
      counting: false,
      rerender: true,
      imgCodeUrl: BASE_URL + '/customer/GetVerifyImg',
    };
  },
  computed: {
    valid() {
      return this.username && this.password;
    },
  },
  methods: {
    onSend() {
      this.counting = true;
      sendSMSCode({ tel: this.username, imgCode: this.captcha }).then(res => {
        if (res.Result == false) {
          this.$toast.fail(res.Info);
          return;
        } else {
          this.$toast.success(res.Info);
        }
      });
    },
    onImgClick() {
      this.rerender = false;
      this.$nextTick(() => {
        this.rerender = true;
        this.imgCodeUrl =
          BASE_URL + '/customer/GetVerifyImg?time=' + new Date().getTime();
      });
    },
    onSubmit() {
      this.$toast.loading();
      resetPassword({
        username: this.username,
        password: this.password,
        code: this.code,
      })
        .then(res => {
          this.$toast.clear();
          if (res.Result) {
            this.$toast.success(res.Info);
            setTimeout(() => {
              this.$router.replace({ name: 'Login' });
            }, 2000);
          } else {
            this.$toast.fail(res.Info);
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';
.page-header {
  font-size: 21px;
}
.reset-password {
  background-color: #fff;
}
.page-body {
  padding: rem(60px);
}
.label {
  font-size: 16px;
  margin-bottom: rem(30px);
}
.van-field {
  border-radius: rem(25px);
  background-color: #f7f7fc;
  font-size: 16px;
  padding-top: rem(24px);
  padding-bottom: rem(24px);
}
.form-field {
  margin-bottom: rem(40px);
}
.submit {
  height: rem(100px);
  line-height: rem(100px);
  width: 100%;
  border-radius: rem(50px);
  margin-top: rem(156px);
  font-size: 16px;
}
.van-count-down {
  color: #fff;
}
.code-btn {
  border-radius: rem(25px);
  margin-left: rem(20px);
  white-space: nowrap;
  color: #fff;
}
</style>
